import { render, staticRenderFns } from "./UserForm.vue?vue&type=template&id=30e7fb9e&scoped=true"
import script from "./UserForm.vue?vue&type=script&lang=ts"
export * from "./UserForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e7fb9e",
  null
  
)

export default component.exports